// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5s-0";
export var startPickingButton = "_5s-1";